var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRepeat({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "repeat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repeat"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 24 0 24 24 0 24",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,6 L12,9 L16,5 L12,1 L12,4 C7.58,4 4,7.58 4,12 C4,13.57 4.46,15.03 5.24,16.26 L6.7,14.8 C6.25,13.97 6,13.01 6,12 C6,8.69 8.69,6 12,6 Z M18.76,7.74 L17.3,9.2 C17.74,10.04 18,10.99 18,12 C18,15.31 15.31,18 12,18 L12,15 L8,19 L12,23 L12,20 C16.42,20 20,16.42 20,12 C20,10.43 19.54,8.97 18.76,7.74 L18.76,7.74 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.7e6d06a1a3d6a075c0ae520450b7e891.svg";
export { ForwardRef as ReactComponent };